import { ListStatus } from '@/store/types';
import Pagination from '@/store/models/pagination';
import SendGridEmail from './sendgrid_email';

export enum SendGridEmailActions {
  LOAD = 'LOAD',
  LOAD_SUMMARY = 'LOAD_SUMMARY',
}

export enum SendGridEmailMutations {
  SET_LIST = 'SET_LIST',
  SET_LIST_PAGINATION = 'SET_LIST_PAGINATION',
  SET_STATUS = 'SET_STATUS',
  SET_SUMMARY = 'SET_SUMMARY',
}

export enum SendGridEmailType {
  Welcome = 'welcome',
  NewDevice = 'new-device',
  Other = 'other',
}

export interface SendGridEmailSummary {
  sends: number;
  delivered: number;
  uniqueOpens: number;
  uniqueClicks: number;
  totalOpens: number;
  totalClicks: number;
  deliveredRate: number;
  openRate: number;
  clickRate: number;
}

export interface SendGridEmailState {
  status: ListStatus;
  list: SendGridEmail[];
  listPagination: Pagination;
  summary: SendGridEmailSummary | null;
}
